import { getSrpSystemCodeCodeInfo } from 'api/pgads'
import { ErrorContext } from 'context'
import { ExportComponent, getApiTargetInfo, rowHeaderRender } from 'core'
import React, { useContext, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import SrpSystemCodeTransfer from './component/SrpSystemCodeTransfer'
import EventDashboard from './EventDashboard'
import * as R from 'ramda'
import { Button, List } from 'antd'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'

import { numCol, strCol } from '@integec/grid-tools/lib/cols'

const SrpEventDashBoard = ({ apiTargetInfo }) => {
  const { setError } = useContext(ErrorContext)

  const [systemCode, setSystemCode] = useState([])
  const [targetKeys, setTargetKeys] = useState([])
  const [visible, setVisible] = useState(false)
  const [systemCodeMap, setSystemCodeMap] = useState({})

  useEffect(
    _ => {
      getSrpSystemCodeCodeInfo(apiTargetInfo).fork(setError, data => {
        const uniqData = R.compose(
          R.sortBy(d => d.srpSystemcode),
          R.uniqBy(s => s.srpSystemcode)
        )(data)

        setSystemCode(uniqData)

        const syscodeMap = R.compose(
          R.reduce((a, b) => ({ ...a, ...b }), {}),
          R.map(d => ({ [d.srpSystemcode]: d.description }))
        )(data)

        setSystemCodeMap(syscodeMap)
      })
    },
    [apiTargetInfo, setError]
  )

  const SystemCodeList = _ => (
    <fieldset
      style={{
        border: '1px solid black',
        // height: '100%',
        width: '100%',
        display: 'grid',
      }}
    >
      <legend style={{ width: '150px', marginBottom: '0px' }}>
        System Code
      </legend>
      <div
        style={{
          display: 'grid',
          // gridTemplateColumns: '90% 10%',
          gridGap: '5px',
        }}
      >
        <Button
          style={{ width: '150px', justifySelf: 'end' }}
          onClick={_ => setVisible(true)}
          type="primary"
        >
          Select System Code
        </Button>
        <div
          style={{
            overflowY: 'auto',
            height: '100px',
          }}
        >
          <List
            size="small"
            bordered
            dataSource={targetKeys}
            renderItem={ex => (
              <List.Item>
                {ex}-{systemCodeMap[ex] || ex}
              </List.Item>
            )}
          />
        </div>
      </div>
    </fieldset>
  )
  const onDialogClose = targetKeys => {
    setVisible(false)
    setTargetKeys(targetKeys)
  }

  return (
    <React.Fragment>
      <EventDashboard
        extraComponentList={[<SystemCodeList key="d" />]}
        extraCriteria={{ srpSystemCode: targetKeys }}
        title="SRP Event Dashboard"
      >
        {({
          data,
          onChangeCriteria,
          height = 350,
          // width = 700,
          fuzzyFilter,
          firstHeight,
        }) => (
          <React.Fragment>
            {/* <Divider /> */}
            <div style={{ display: 'grid', gridTemplateColumns: 'auto auto' }}>
              <div style={{ width: '1100px' }}>
                <Grid
                  sortEnabled
                  data={data.SRPSystemCodeData || []}
                  headers={headerWithFormatter}
                  altBy={u => u.type}
                  altBgColor="#ebebeb"
                  // onEditInfoChange={info => editRow(info)}
                  // editInfo={editInfo}
                  render={virtualizedGridRenderer({
                    autoFixColByKey: true,
                    rowHeaderRender,
                    headerRowHeight: 30,
                    height: height - firstHeight - 20,
                    width: 1100,
                  })}
                  isEditable={false}
                  selectionMode="single"
                  selectionType="row"
                  initialSortOptions={headerWithFormatter}
                  sortOptions={headerWithFormatter}
                  fuzzyFilter={fuzzyFilter}
                />
              </div>
              <div style={{ left: '1100px' }}>
                <ExportComponent
                  data={data.SRPSystemCodeData || []}
                  headers={headerWithFormatter}
                  fileName="System Code"
                  btnStyle={{ marginRight: '10px' }}
                  // disabled={data.length <= 0}
                />
              </div>
            </div>
            {visible && (
              <SrpSystemCodeTransfer
                dataSource={systemCode}
                defaultTargetKeys={targetKeys}
                visible={visible}
                setTargetKeys={setTargetKeys}
                onOK={keys => {
                  onDialogClose(keys)
                  onChangeCriteria()
                }}
              />
            )}
          </React.Fragment>
        )}
      </EventDashboard>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(SrpEventDashBoard)

const headerWithFormatter = [
  strCol({
    ident: 'type',
    display: 'Type',
    width: 400,
    sortOrder: 'asc',
    isFiltered: true,
  }),
  strCol({
    ident: 'system',
    display: 'System',
    width: 400,
    sortOrder: 'asc',
    isFiltered: true,
  }),
  numCol({
    ident: 'lostMWH',
    display: 'Lost MWH',
    width: 200,
    sortOrder: 'asc',
    isFiltered: true,
  }),
]
